{
    "Detailstitle": "Dettagli del segmento di chiamata",
    "Recordingtitle": "Registrazione del segmento di chiamata",
    "Details": "Dettagli",
    "Recording": "Registrazione",
    "Value": "Valore",
    "Collapseall": "Chiudi tutti",
    "FieldStatistic": "Campo \/ Statistica",
    "Calldatetimevalues": "Valori di data e ora della chiamata",
    "Deviceinformation": "Informazioni sul dispositivo",
    "Calltypestatus": "Tipo e stato della chiamata",
    "Callmovement": "Informazioni sullo scenario del movimento delle chiamate",
    "Calldurationvalues": "Valori di durata della chiamata",
    "Telephoneinformation": "Informazioni sul numero di telefono",
    "Acdinformation": "Informazioni sull'agente ACD",
    "Associatedtelephonyenvironment": "Ambiente di telefonia associato",
    "Diagnosticvalues": "Valori diagnostici",
    "Previous": "Precedente",
    "Next": "Avanti",
    "Playrecording": "Riproduzione della registrazione",
    "Errorplayrecording": "Recupero della registrazione non riuscito",
    "Norecording": "Nessuna registrazione",
    "Retrievingrecordings": "Recupero delle registrazioni...",
    "Backtodetails": "Torna ai dettagli",
    "Segmentid": "Copiare l'ID della catena di segmenti",
    "Copied": "Copiato!",
    "Help": "Aiuto",
    "Close": "Chiudere",
    "RecordingTimeoutError": "È stato superato il numero massimo di tentativi di ottenere le registrazioni di questa chiamata.",
    "EditableHint": "Fare clic sulla descrizione per modificare questo campo.",
    "EditPlaceholder": "Fare clic qui per aggiungere la descrizione",
    "ReloadDataP1": "Una voce è stata aggiornata di recente, ",
    "ReloadDataP2": "clicca qui ",
    "ReloadDataP3": "per ricaricare i dati.",
    "DescMaxLengthValidation": "La lunghezza massima dei caratteri è di 100.",
    "ConfirmChange": "Confermare",
    "CancelChange": "Annullamento",
    "NAME": "CallDetails",
    "AccountCodeHint": "Fare clic sul codice del conto per modificare questo campo.",
    "AccountCodePlaceholder": "Fare clic qui per aggiungere il codice del conto",
    "DescriptionHint": "Fare clic sulla descrizione per modificare questo campo.",
    "DescriptionPlaceholder": "Fare clic qui per aggiungere la descrizione",
    "NoAccountCodes": "Nessun codice conto disponibile",
    "First": "Primo",
    "Last": "Scorso",
    "CallJourneyTitle": "Chiama il viaggio",
    "CallRecordingTitle": "Registrazione delle chiamate",
    "CallSegmentTitle": "Segmento {} di {}",
    "TabTextTimeline": "Cronologia",
    "TabTextSegments": "Segmenti",
    "TabTextRecording": "Registrazione",
    "StatisticDeviceCalled": "Nome\/Numero chiamato",
    "StatisticDeviceCalling": "Nome\/Numero chiamante",
    "StatisticTotalCallTime": "Tempo totale della chiamata",
    "StatisticStatus": "Stato",
    "Answered": "Risposto",
    "NotAnswered": "Non risposto",
    "StatisticTotalCallTimeInProgress": "Chiamata in corso"
}